import React from "react";
import { ClipboardList } from "lucide-react";
import { SectionFrame } from "./SectionFrame";
import { StatusBadge } from "../../StatusBadge";

const AvailabilityRow = ({ req, testId }) => (
  <div className="flex items-start justify-between gap-3 py-2.5 border-t border-slate-100 first:border-t-0" data-testid={testId}>
    <div>
      <p className="text-sm font-medium text-slate-700">
        {req.date || (req.recurring_weekday !== undefined && req.recurring_weekday !== null ? `Weekly - ${req.recurring_weekday}` : "-")}
      </p>
      <p className="text-xs text-slate-500">{req.availability_type || req.request_type}{req.notes ? ` - ${req.notes}` : ""}</p>
      {req.decision_note && <p className="text-xs text-slate-400 mt-0.5">Manager note: {req.decision_note}</p>}
      {req.clarification_requested_note && <p className="text-xs text-amber-600 mt-0.5">Clarification requested: {req.clarification_requested_note}</p>}
    </div>
    <StatusBadge status={req.status} />
  </div>
);

/** Monthly Record - Availability section (spec P0-B): submitted availability and time-off
 * requests targeting this period, with review status/manager notes made explicit. */
export const AvailabilitySection = ({ data, loading, error, onRetry }) => {
  const availability = data?.availability_submissions || [];
  const timeOff = data?.time_off_requests || [];
  const isEmpty = availability.length === 0 && timeOff.length === 0;
  return (
    <SectionFrame
      title="Availability" icon={ClipboardList} testId="monthly-availability-section"
      loading={loading} error={error} onRetry={onRetry}
      isEmpty={isEmpty}
      emptyMessage="No availability submission exists for this period."
    >
      {availability.length > 0 && (
        <div className="mb-3">
          <p className="text-[11px] text-slate-400 uppercase mb-1">Availability submissions</p>
          {availability.map((req) => <AvailabilityRow key={req.id} req={req} testId={`monthly-availability-row-${req.id}`} />)}
        </div>
      )}
      {timeOff.length > 0 && (
        <div>
          <p className="text-[11px] text-slate-400 uppercase mb-1">Time-off requests</p>
          {timeOff.map((req) => <AvailabilityRow key={req.id} req={req} testId={`monthly-time-off-row-${req.id}`} />)}
        </div>
      )}
    </SectionFrame>
  );
};
